<template>
  <b-modal
    v-if="lobbyOffer"
    id="modal-offer-daily-2"
    class="custom-modal1"
    :hide-footer="true"
    modal-class="custom-modal1"
    @hidden="onHidden"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <a href="#" class="close-button" @click="close()"> </a>
      <div class="headline">
        <img
          :src="
            require(`@/assets/img/shop/offers/offer-overlay-glueckstag-2-panel-hl-${$store.state.locale}.png`)
          "
          class="w-100"
        />
      </div>
    </template>

    <template slot="default">
      <div
        class="bg-wrapper bg-img w-100 h-100"
        :style="{
          backgroundImage: `url(${$whitelabel.assets.offers.specialOffer.twoPanels})`,
          width: '1000px',
        }"
      >
        <div v-if="rewards[0]" class="offer-reward-container1">
          <div class="w-100">
            <BaseAsset
              asset="primary"
              size="big"
              style="width: 66px; height: 66px"
            />
          </div>
          <div
            class="w-100 d-inline-flex align-items-center justify-content-center"
            :style="{ visibility: rewards[0].gold > 0 ? 'visible' : 'hidden' }"
          >
            <div class="yellow-text bold" style="font-size: 40px">
              {{ formatNumber(rewards[0].gold) }}
            </div>
          </div>

          <div
            class="w-100 d-inline-flex align-items-center justify-content-center"
            :style="{ visibility: rewards[0].crown > 0 ? 'visible' : 'hidden' }"
          >
            <div class="yellow-text bold" style="font-size: 38px">
              {{ formatNumber(rewards[0].crown) }} x
            </div>
            <BaseAsset asset="secondary" size="big" class="ms-2 yellow-text" />
          </div>

          <div
            class="w-50 mx-auto d-flex align-items-center justify-content-between"
          >
            <div v-if="rewards[0].card > 0">
              <BaseAsset asset="cards" size="big" />
              <div class="primary-accent">
                {{ formatNumber(rewards[0].card) }} x
              </div>
            </div>

            <div v-if="rewards[0].loyalty > 0">
              <BaseAsset asset="loyalty" size="big" />
              <div class="primary-accent">
                {{ formatNumber(rewards[0].loyalty) }} x
              </div>
            </div>

            <div v-if="rewards[0].elixir > 0">
              <BaseAsset asset="tertiary" size="big" />
              <div class="primary-accent">
                {{ formatNumber(rewards[0].elixir) }} x
              </div>
            </div>

            <div v-if="rewards[0].expbooster > 0">
              <BaseAsset asset="booster" size="big" />
              <div class="primary-accent">
                {{ Math.round(rewards[0].expbooster / 60) }} Min.
              </div>
            </div>
          </div>
          <div class="submit-button" @click="buyItem(0, 'Offer', 'Daily')">
            <div>
              {{ $t("shop.offers.buy_button", { 0: "" }) }}
              <br />
              <span class="big">{{ formatPrice(price[0]) }} €</span>
            </div>
          </div>
        </div>

        <div v-if="rewards[1]" class="offer-reward-container2">
          <img
            :src="$whitelabel.currencies.primary.triple"
            style="width: 220px"
          />

          <div
            class="w-100 text-center"
            :style="{ visibility: rewards[1].gold > 0 ? 'visible' : 'hidden' }"
          >
            <div class="yellow-text bold" style="font-size: 50px">
              {{ formatNumber(rewards[1].gold) }}
            </div>
          </div>

          <div
            class="w-100 d-flex align-items-center justify-content-center"
            :style="{ visibility: rewards[1].crown > 0 ? 'visible' : 'hidden' }"
          >
            <div class="yellow-text bold" style="font-size: 48px">
              {{ formatNumber(rewards[1].crown) }} x
            </div>
            <BaseAsset asset="secondary" size="big" class="ms-2 yellow-text" />
          </div>

          <div
            class="w-50 mx-auto d-flex align-items-center justify-content-between"
          >
            <div v-if="rewards[1].card > 0">
              <BaseAsset asset="cards" size="big" />
              <div class="primary-accent">
                {{ formatNumber(rewards[1].card) }} x
              </div>
            </div>

            <div v-if="rewards[1].loyalty > 0">
              <BaseAsset asset="loyalty" size="big" />
              <div class="primary-accent">
                {{ formatNumber(rewards[1].loyalty) }} x
              </div>
            </div>

            <div v-if="rewards[1].elixir > 0">
              <BaseAsset asset="tertiary" size="big" />
              <div class="primary-accent">
                {{ formatNumber(rewards[1].elixir) }} x
              </div>
            </div>

            <div v-if="rewards[1].expbooster > 0" class="package-icon">
              <BaseAsset asset="booster" size="big" />
              <div class="primary-accent">
                {{ Math.round(rewards[1].expbooster / 60) }} Min.
              </div>
            </div>
          </div>
          <div class="submit-button" @click="buyItem(1, 'Offer', 'Daily')">
            <div>
              {{ $t("shop.offers.buy_button", { 0: "" }) }}
              <br />
              <span class="big">{{ formatPrice(price[1]) }} €</span>
            </div>
          </div>
        </div>
        <div class="badge-big">
          <span>
            <i18next :translation="$t('shop.offers.badge4a')"
              ><template #0
                ><div class="big">
                  {{ $t("shop.offers.badge4.today") }}
                </div></template
              ></i18next
            ></span
          >
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import offerModalContent from "@/mixins/offerModalContent.js";
import BaseAsset from "@/components/base/base-asset.vue";

export default {
  name: "ModalOfferDaily2",
  components: { BaseAsset },
  mixins: [offerModalContent],
  data() {
    return { isPipelineOffer: true };
  },
  mounted: function () {
    this.$bvModal.show("modal-offer-daily-2");
  },
};
</script>
<style lang="scss">
$modal-width: 1000px;
$modal-height: 700px;

#modal-offer-daily-2 {
  .modal-dialog {
    top: 50px;
    max-width: $modal-width;
    height: $modal-height;

    @media (max-height: 750px) {
      transform: scale(0.8);
      top: -60px;
      margin-bottom: -20%;
    }
  }

  .close-button {
    top: 50px;
    right: -30px;
  }
}
</style>

<style scoped lang="scss">
#modal-offer-daily-2 {
  .headline {
    position: absolute;
    top: 10px;
    left: -25px;
  }
  .package-bonus-icons {
    padding: 0 10px;
    white-space: nowrap;
    color: $primary-accent;
    .package-icon {
      width: 93px;
      text-align: center;
      font-size: 22px;
    }
  }

  .offer-reward-container1 {
    top: 215px;
    line-height: 1.2;
    text-align: center;
    width: 300px;
    position: absolute;
    left: 249px;
    height: 395px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .submit-button {
      width: 200px;
      height: 72px;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: white;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      display: inline-flex;
      line-height: 1.1;
      text-shadow: 1px 2px 4px $text-shadow-dark-green;

      .big {
        color: white;
        font-family: Ubuntu-Bold;
        font-size: 36px;
      }
    }
  }

  .offer-reward-container2 {
    top: 180px;
    line-height: 1.2;
    text-align: center;
    width: 300px;
    position: absolute;
    right: 75px;
    height: 450px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .submit-button {
      width: 352px;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: white;
      text-transform: uppercase;
      cursor: pointer;
      font-family: Ubuntu-Bold;
      text-align: center;
      padding-left: 28%;
      padding-right: 23%;
      display: inline-flex;
      line-height: 1;
      text-shadow: 1px 2px 4px $text-shadow-dark-green;

      .big {
        color: white;
        font-family: Ubuntu-Bold;
        font-size: 48px;
      }
    }
  }

  .badge-big {
    width: 180px;
    height: 180px;
    background: url(~@/assets/img/shop/offers/badge-big-back3.png) no-repeat;
    background-size: cover;
    align-items: center;
    justify-content: center;
    font-size: 25.2px;
    color: white;
    text-transform: uppercase;
    font-family: Ubuntu-Bold;
    text-align: center;
    display: inline-flex;
    filter: drop-shadow(0 2px 4px $btn-drop-shadow);
    padding-left: 35px;
    padding-right: 35px;
    padding-top: 0;
    line-height: 1.2;
    position: absolute;
    right: 20px;
    top: -15px;
    transform: rotate(8deg);
    text-shadow: 4px 4px 4px $drop-shadow-dark;

    .big {
      color: white;
      font-family: Ubuntu-Bold;
      font-size: 43.2px;
    }
  }
}
</style>
